'use strict';

// const { default: Swiper } = require("swiper");

// touch
indi.app.blocks.setTouch = function () {
	var support_touch = ('ontouchend' in document);
	if (support_touch)
		$('body').addClass('touch-content');

	window.support_touch = support_touch;
};





// active block
indi.app.blocks.activeBlock = function () {
	// js-toggle-block-activity
	$(document).on('click', '.js-toggle-block-activity', function (event) {
		var target = $(this).data('target');

		if (!$(target).hasClass('js-active-block')) {
			if (!$(target).closest('.js-active-block').length)
				$('.js-active-block').removeClass('active js-active-block').trigger('toggleBlockActivity');
			else
				$(target).closest('.js-active-block').find('.js-active-block').removeClass('active js-active-block').trigger('toggleBlockActivity');

			$('body').removeClass('toggle-block-open');
		}

		if (target !== undefined) {
			$(target).toggleClass('active').toggleClass('js-active-block').trigger('toggleBlockActivity');

			$('body').toggleClass('toggle-block-open');
		}

		event.preventDefault();
		//return false;
	});


	// js-active-block
	$(document).on('click', function (event) {
		if ($(event.target).closest('.js-toggle-block-activity').length)
			return;

		if ($(event.target).closest('.js-active-block').length) {
			$(event.target).closest('.js-active-block').find('.js-active-block').removeClass('active js-active-block').trigger('toggleBlockActivity');
			return;
		}
		$('.js-active-block').removeClass('active js-active-block').trigger('toggleBlockActivity');
		$('body').removeClass('toggle-block-open');

		event.stopPropagation();
	});



	// js-toggle-block
	$(document).on('click', '.js-toggle-block', function (event) {
		var target = $(this).data('target');

		if (target !== undefined) {
			$(target).toggleClass('active').trigger('toggleBlock');
		}

		event.preventDefault();
		//return false;
	});


	// останавливает всплытие события к родительским элементам
	$(document).on('toggleBlock toggleBlockActivity', '*', function (event) {
		event.stopPropagation();
	});
};





// js-down
indi.app.blocks.jsDown = function () {
	var scrollState = false;

	$(document).on('click', '.js-down', function (event) {
		var target = $(this).attr('href');
		var scrollTarget = $(target);

		if (scrollTarget.length > 0) {
			scrollState = true;

			var scrollY = scrollTarget.offset().top;

			$('body,html').stop().animate({ scrollTop: scrollY }, 500, 'swing', function () {
				scrollState = false;
			});
		}

		event.preventDefault();
	});
};

indi.app.blocks.jsDown.exists = function () {
	return $('.js-down').length > 0;
};





// validation
indi.ui.validation = new function () {
	if ($.validator) {
		$.extend($.validator.messages, {
			required: 'Поле обязательно для заполнения',
			digits: 'Введите только цифры',
			phone: 'Некорректный номер телефона',
			email: 'Некорректный email',
			date: 'Некорректная дата'
		});


		$.validator.addMethod(
			'regexp', function (value, element, params) {
				var re = new RegExp(params);
				return this.optional(element) || re.test(value);
			},
			'Неверный формат'
		);
		$.validator.addMethod(
			'date', function (value, element) {
				return this.optional(element) || /^(0[1-9]|[12][0-9]|3[01])\.(0[1-9]|1[012])\.((19|20)\d{2})$/.test(value);
			},
			'Некорректная дата'
		);
		$.validator.addMethod(
			'email', function (value, element) {
				return this.optional(element) || /^[a-zA-Zа-яА-Я_\d][-a-zA-Zа-яА-Я0-9_\.\d]*\@[a-zA-Zа-яА-Я\d][-a-zA-Zа-яА-Я\.\d]*\.[a-zA-Zа-яА-Я]{2,4}$/.test(value);
			}
		);
		$.validator.addMethod(
			'phone', function (value, element) {
				return this.optional(element) || /^\+7 \([\d]{3}\) [\d]{3}\-[\d]{2}\-[\d]{2}$/.test(value);
			}
		);


		$.validator.addClassRules({
			'js-validate-text': {
				regexp: '/^[A-Za-zА-ЯЁа-яё\s\-]*$/'
			},
			'js-validate-cyrillic': {
				regexp: '/^[А-ЯЁа-яё\s\-]*$/'
			},
			'js-validate-digits': {
				digits: true
			},
			'js-validate-date': {
				date: true
			},
			'js-datepicker': {
				date: true
			},
			'js-validate-phone': {
				phone: true
			},
			'js-validate-email': {
				email: true
			}
		});


		$.validator.setDefaults({
			//debug: true,
			ignore: '[type="hidden"]',
			errorClass: 'has-error',
			validClass: '',
			errorElement: 'label',
			onfocusout: function (element) {
				$(element).valid();
			},
			highlight: function (element, errorClass, validClass) {
				$(element).closest('.form-group').addClass(errorClass);
			},
			unhighlight: function (element, errorClass, validClass) {
				$(element).closest('.form-group').removeClass(errorClass);
			},
			errorPlacement: function (error, element) {
				error.addClass('form-error').appendTo(element.parents('.form-group'));
			}
		});


		$(document).on('change', 'form[data-validate="Y"] .selectfix-container select, form[data-validate="Y"] .js-datepicker', function () {
			$(this).trigger('focusout');
		});
	}
};



// validateForm
indi.app.blocks.validateForm = function () {
	this.initDOM = function (domElement) {
		domElement.find('form[data-validate="Y"]').validate();
	};

	indi.ui.onInit(this.initDOM, this);
};

indi.app.blocks.validateForm.exists = function () {
	return $('form[data-validate="Y"]').length > 0;
};

// Product slider
indi.app.blocks.sliderProduct = function () {
	var galleryTop = new Swiper('.js-product-slider', {
		pagination: {
			el: '.swiper-pagination',
			clickable: true
		}
	});
};

indi.app.blocks.sliderProduct.exists = function () {
	return $('.js-product-slider').length > 0;
};

// $(window).on('load', function () {
//   $('.js-preloader').fadeOut(400);
// });


// sliders

const eticaSwiper= new Swiper('#etica-learn-more .swiper', {
    spaceBetween: 20,
    slidesPerView: 1,
	autoHeight: true,

	navigation: {
    	nextEl: '.swiper-button-next',
    	prevEl: '.swiper-button-prev',
  	},
  	breakpoints: {
    	1000: {
    		enabled: false,
    	}
  	},
})

indi.app.blocks.slider = function () {
	var galleryThumbs = new Swiper('.gallery-thumbs', {
		spaceBetween: 20,
		slidesPerView: 3,
		loop: true,
		freeMode: true,
		loopedSlides: 0,
		watchSlidesVisibility: true,
		watchSlidesProgress: true,
	});
	var galleryTop = new Swiper('.gallery-top', {
		spaceBetween: 10,
		autoHeight: true,
		loop: true,
		loopedSlides: 0,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		thumbs: {
			swiper: galleryThumbs,
		},
		breakpoints: {
			575: {
				pagination: {
					clickable: true,
					el: '.swiper-pagination',
					type: 'bullets',
				},
			}
		}
	});
}

indi.app.blocks.slider.exists = function () {
	return $('.gallery-top').length > 0;
};

const inspiriaSwiper = new Swiper('#modal1 .swiper', {
	autoHeight: true,
	navigation: {
    	nextEl: '.swiper-button-next',
    	prevEl: '.swiper-button-prev',
  	},
	slidesPerView: 1,
	slidesPerGroup: 1,
  	breakpoints: {
    	970: {
			slidesPerView: 2,
			slidesPerGroup: 2,
			
    	}
  	},
})

const valenaSwiper = new Swiper('#modal3 .swiper', {
	autoHeight: true,
	
   	navigation: {
    	nextEl: '.swiper-button-next',
    	prevEl: '.swiper-button-prev',
  	},

  	breakpoints: {
    	1300: {
        	enabled: false,
    	}
  	},
})

const sksSwiper = new Swiper('#modalCanalCable .swiper', {
	autoHeight: true,
	
   	navigation: {
    	nextEl: '.swiper-button-next',
    	prevEl: '.swiper-button-prev',
  	},

  	breakpoints: {
    	769: {
    	}
  	},
})

const plexoSwiper = new Swiper('#modal8 .swiper', {
	autoHeight: true,

   	navigation: {
    	nextEl: '.swiper-button-next',
    	prevEl: '.swiper-button-prev',
	},
	
	slidesPerView: 1,
	slidesPerGroup: 1,
  	breakpoints: {
    	1000: {
			slidesPerView: 2,
			slidesPerGroup: 2,
			
    	}
  	},
})

const practiSwiper = new Swiper('#practibox .swiper', {
	autoHeight: true,

   	navigation: {
    	nextEl: '.swiper-button-next',
    	prevEl: '.swiper-button-prev',
  	},

  	breakpoints: {
    	800: {
        	enabled: false,
    	}
  	},
})

const celianeSwiper = new Swiper('#modal4 .swiper', {
	autoHeight: true,

   	navigation: {
    	nextEl: '.swiper-button-next',
    	prevEl: '.swiper-button-prev',
  	},

  	breakpoints: {
    	1120: {
        	enabled: false,
    	}
  	}
})

const heliumSwiper = new Swiper('#helium .swiper', {
	autoHeight: true,

   	navigation: {
    	nextEl: '.swiper-button-next',
    	prevEl: '.swiper-button-prev',
  	},

  	breakpoints: {
    	500: {
        	enabled: false,
    	}
  	}
})

const lifeSwiper = new Swiper('#life .swiper', {
	pagination: {
		el: '.swiper-pagination',
		clickable: true
	},
	navigation: {
    	nextEl: '.swiper-button-next',
    	prevEl: '.swiper-button-prev',
  	},

   breakpoints: {
	 500: {
		 enabled: false,
	 }
   }
})

const axoluteSwiper = new Swiper('#axolute .swiper', {


	navigation: {
    	nextEl: '.swiper-button-next',
    	prevEl: '.swiper-button-prev',
  	},

   breakpoints: {
	 500: {
		 enabled: false,
	 }
   }
})


// D2021-12-23 starting line. 
const rxSwiper = new Swiper('#rx .swiper', {
	navigation: {
		nextEl: '.swiper-button-next',
    	prevEl: '.swiper-button-prev',
	},
	
	autoHeight: true,
	
    breakpoints: {
		1200: {
			enabled: false,
		}
	}
})
const txSwiper = new Swiper('#tx .swiper', {
	navigation: {
		nextEl: '.swiper-button-next',
    	prevEl: '.swiper-button-prev',
	},
	
	autoHeight: true,
	
    breakpoints: {
		1200: {
			enabled: false,
		}
	}
})
const quteoSwiper = new Swiper('#quteoModal .swiper', {
	
	autoHeight: true,
	enabled: false,
	
})
const dxSwiper = new Swiper('#dx .swiper', {
	navigation: {
		nextEl: '.swiper-button-next',
    	prevEl: '.swiper-button-prev',
	},
	
	autoHeight: true,
	
    slidesPerView: 1,
	slidesPerGroup: 1,
  	breakpoints: {
    	1260: {
			slidesPerView: 2,
			slidesPerGroup: 2,
			
    	}
  	},
})
// D2021-12-23 ending line.